<template>
  <div>
    <generic-container
      :title="$t('pet information')"
      icon="cat"
      :searchable="false"
      :show_plus="false"
      :configurable="false"
      :header_buttons="header_buttons"
    >
      <div class="ui items">
        <div class="item">
          <div class="ui small circular image">
            <img src="/images/icons/pet.png" />
          </div>
          <div class="content">
            <a class="header">{{ pet.name }}</a>
            <div class="meta">
              <span
                >{{ $t("since") }}
                {{
                  pet.create_date
                    | formatDate(enterprise_setup.simple_date_format)
                }}</span
              >
            </div>
            <div class="description">
              <div class="ui divided selection list">
                <a
                  class="item"
                  v-for="(attribute, index) in pet.setup.attributes"
                  v-bind:key="index"
                >
                  <div class="ui primary tag label">{{ attribute.name }}</div>
                  <div class="ui basic label">{{ attribute.value }}</div>
                </a>
              </div>
            </div>
            <div class="extra"></div>
          </div>
        </div>
      </div>
    </generic-container>
    <component
      :is="submodule.setup.plugin.component"
      :module="submodule"
      :pet="pet"
      v-for="(submodule, index) in submodules"
      v-bind:key="index"
    ></component>
    <template v-for="(mdl, index) in pet_modals">
      <component
        :is="mdl"
        :key="index"
        :pet="pet"
        v-on:destroy="pet_modal_destroy"
        v-on:succedded="pet_modal_succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  load_submodules,
  enterprise_setup,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import PetDocumentPlugin from "@/modules/pet_document/PetDocumentPlugin";
import PetCustomerRelationshipPlugin from "@/modules/pet_customer/PetCustomerRelationshipPlugin";
// import CustomerEmailPlugin from "@/components/CustomerEmailPlugin";

import PetModal from "./PetModal";

// @ is an alias to /src
export default {
  name: "Pet",
  components: {
    "generic-container": GenericContainer,
    PetDocumentPlugin,
    PetCustomerRelationshipPlugin,
    // CustomerEmailPlugin
  },
  filters: filters,
  data() {
    return {
      pet: { setup: {} },
      configuration: {},
      header_buttons: [
        {
          color: "orange",
          icon: "edit",
          click: this.edit_pet,
        },
        {
          color: "red",
          icon: "trash",
          click: this.remove_pet,
        },
      ],
      pet_modals: [],
      submodules: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    remove_pet() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove pet?"),
        function() {
          local_api(vm, "post", "/pet/do-remove", { u: vm.pet.uuid })
            .then(() => {
              vm.$router.push({
                name: "PetIndex",
              });
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    edit_pet() {
      this.pet_modals.push(PetModal);
    },
    pet_modal_destroy() {
      this.pet_modals = [];
    },
    pet_modal_succedded(pet) {
      pet.setup = JSON.parse(pet.setup);
      this.pet = pet;
    },
  },
  mounted() {
    let vm = this;

    load_submodules(vm, "pet");

    local_api(vm, "post", "/pet/do-get-configuration")
      .then((configuration) => {
        vm.configuration = configuration;
      })
      .catch((err) => {
        error_toast(err);
      });

    let pet_uuid = this.$route.query.i;
    if (pet_uuid) {
      local_api(vm, "post", "/pet/do-get", { u: pet_uuid })
        .then((pet) => {
          vm.pet = pet;
        })
        .catch((err) => {
          error_toast(err);
        });
    } else {
      error_toast(this.$t("no pet"));
    }
  },
  watch: {},
};
</script>
